{
  "ariaLabelCloseBtn": "Lukk",
  "ariaLabelBackButton": "Gå tilbake"
}
